module.exports = __webpack_public_path__ + "img/load-img.0297c6ce.svg";